require('./sentiment-widget.scss');
require('./sentiment-feedback-form.js');
var tracking = require('./sentiment-tracking.js');

window.EDM || (window.EDM = {});
var EDM = window.EDM;
EDM.SentimentWidget || (EDM.SentimentWidget =
{
    smileyData: [
        { name: 'good', value: 1 },
        { name: 'neutral', value: 5 },
        { name: 'bad', value: 9 }
    ]
});

EDM.SentimentWidget.WidgetController = {
    initWidget: function(name, ele, initialRating, noDrawer) {
        var _smileyContainer = ele.querySelector('.sentiment-link-area');
        //var _feedbackFormEle = $('#sentimentFeedbackForm');
        var _selectedIndex = -1;
        _smileyContainer.addEventListener('click', _smileyContainerClickHandler);
        var _smileyNames = ['.sentiment-icon.good', '.sentiment-icon.neutral', '.sentiment-icon.bad'];

        _smileyNames.forEach(function(val, idx) {
            _smileyContainer.querySelector(val).setAttribute('data-link-click',
                JSON.stringify(tracking.makeSmileyPixel(name, idx)));
        });

        function _findClickedIndex(target) {
            return Array.prototype.indexOf.call(_smileyContainer.children, target);
        }

        function _toggleIndex(idx) {
            _smileyContainer.classList.toggle(EDM.SentimentWidget.smileyData[idx].name);
        }

        function _smileyContainerClickHandler(e) {
            var target = e.target || e.srcElement;
            if (!target.classList.contains('sentiment-icon')) {
                return;
            }
            var idx = _findClickedIndex(target.parentElement);
            _activateClicked(idx);
            //tracking.fireSmileyClickPixel(name, idx);
            if (!noDrawer) {
                // open up drawer
                EDM.SentimentWidget.FeedbackForm.openForm(name, idx);
            }
        }

        function _activateClicked(idx) {
            if (_selectedIndex !== -1) {
                _toggleIndex(_selectedIndex);
            } else {
                _smileyContainer.classList.remove(_smileyContainer.classList.item(1));
            }
            _selectedIndex = idx;
            _toggleIndex(_selectedIndex);
        }

        if (initialRating) {
            _activateClicked(initialRating);
        }  
    }
};

$(document).ready(function() {
    var _sentimentWidgets = document.querySelectorAll('.sentiment-widget-container');
    [].forEach.call(_sentimentWidgets, function(widget) {
        var parent = widget.parentElement;
        EDM.SentimentWidget.WidgetController.initWidget(parent.getAttribute('data-sentiment-name') || 'sentiment0',
            widget,
            parent.getAttribute('data-initial-rating') || 0,
            !!parent.getAttribute('data-nodrawer'));
    });
});





//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/sentiment-widget/sentiment-widget.js
// module id = 197
// module chunks = 0 1